type BaseBigTextType = {
  label: string;
  smalllabel?: string;
  classProps?: string;
  textSize?: string;
};

export default function BaseBigText(props: BaseBigTextType) {
  return (
    <div className={`flex flex-col items-center ${props.classProps}`}>
      <p className="font-headline text-xl font-semibold text-primary tracking-widest -mb-2">
        {props.smalllabel}
      </p>
      <h4
        className={`${
          props.textSize ? props.textSize : "text-7xl"
        } uppercase font-headline font-semibold tracking-tighter drop-shadow-xl`}
      >
        {props.label}
      </h4>
    </div>
  );
}
